
        import config from './src/config'

        const CONFIG_WELLFUNNEL_STUDIO = {
            WELLFUNNEL_API_URL: config.PREVIEW_API_URL,
            WELLFUNNEL_API_KEY: config.PREVIEW_API_URL,
            PRODUCT_API_ID: 'walking',
            PRODUCT_API_URL: config.PREVIEW_PRODUCT_API_URL,
            PRODUCT_API_KEY: config.PREVIEW_PRODUCT_API_KEY,
            PRODUCT_API_VERSION: '2',
            PROJECT_NAME: 'walkfit',
            //just need string for init preview
            CABINET_URL: ''
        }
        window.wellFunnelConfig = {
            ...CONFIG_WELLFUNNEL_STUDIO,
            // Trustpilot widget configuration — required for t__trustpilot template preview.
            // TRUSTPILOT_BUSINESS_ID comes from config.js (fill from Vault, same value as menscoach).
            // Template IDs and tokens are public widget constants shared across all products.
            TRUSTPILOT_BUSINESS_ID: config.TRUSTPILOT_BUSINESS_ID,
            TRUSTPILOT_DEFAULT_TEMPLATE: '53aa8912dec7e10d38f59f36',
            TRUSTPILOT_MINI_CAROUSEL_TEMPLATE: '539ad0ffdec7e10e686debd7',
            TRUSTPILOT_SLIDER_TEMPLATE: '54ad5defc6454f065c28af8b',
            TRUSTPILOT_FLEX_TEMPLATE: '54197383fd9dceac42a68694',
            TRUSTPILOT_DEFAULT_TOKEN: '9fd30ca2-ce6e-4ed1-a93b-ad9d7df7ca70',
            TRUSTPILOT_MINI_CAROUSEL_TOKEN: '62c6bcc1-c20f-489b-a83b-9ed924882870',
            TRUSTPILOT_SLIDER_TOKEN: '474d040e-9e7e-44cb-9b70-7a9c257cf947',
            TRUSTPILOT_FLEX_FITNESS_TOKEN: '055371a8-22e5-4352-82c1-5e77a5f683a6',
            TRUSTPILOT_FLEX_WORKOUT_TOKEN: '68429c21-d49f-4c81-82fa-0ebd124e6a28',
            TRUSTPILOT_FLEX_NUTRITION_TOKEN: 'fa7218cb-5d39-4933-8066-9435c3f5a7c7',
            TRUSTPILOT_FLEX_WEIGHT_LOSS_TOKEN: '502c2cad-3ab8-41bf-a1cd-49b9906aeac0',
            TRUSTPILOT_FLEX_LBS_TOKEN: 'ef2a3767-8afb-4529-84e8-9ded2f799a37',
            TRUSTPILOT_REVIEW_URL: 'https://es.trustpilot.com/review/muscle-booster.io',
        }
    